import React from 'react';
import { Box, Link, Paragraph, Text } from 'bumbag';

import * as ApplicationContext from 'legacy/context/ApplicationContext';

import { THO_PRIVACY_POLICY_URL, THO_TERMS_AND_CONDITION_URL, THO_URL } from '../../../../constants';
export interface SidebarFooterProps {
  className: string | null;
}
export default function SidebarFooter({ className, ...props }: SidebarFooterProps) {
  return (
    <ApplicationContext.Consumer>
      {({ application }: any) => (
        // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
        <Box className={className && className} {...props}>
          <Paragraph marginBottom="major-1">
            <Text fontSize="150" fontWeight="semibold">
              {new Date().getFullYear()} © Tyro Health
            </Text>
          </Paragraph>
          <Paragraph>
            <Text fontSize="150">
              <Link href={THO_URL} color="white">
                About
              </Link>
              {' | '}
              <Link href={application.termsUrl || THO_TERMS_AND_CONDITION_URL} color="white">
                Terms
              </Link>
              {' | '}
              <Link href={application.privacyUrl || THO_PRIVACY_POLICY_URL} color="white">
                Privacy
              </Link>
            </Text>
          </Paragraph>
        </Box>
      )}
    </ApplicationContext.Consumer>
  );
}
